import { Observable } from 'rxjs';
import { ContableAcountsRepository } from '../domain/acounts/repository';

import HttpClient from '../utils/http-client';
import { Filter } from '@/domain/pagination/models';

export class ContableAcountsRepositoryImplementation extends ContableAcountsRepository {
  getContableAcounts(page: number, limit: number, filters: Filter[]): Observable<any> {
    const httpClient = new HttpClient("", "");
    const filterStr = filters.map(f => `&${encodeURIComponent(f.label)}=${encodeURIComponent(f.value)}`).join('');
    return httpClient.get<any>(`/accounting/accounts?page=${page}&limit=${limit}${filterStr}`);
  }

  getAllSubContableAcounts(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`/accounting/subaccounts?limit=1000`);
  }

  getSubContableAcounts(uid: string, cid: string | null, id: number): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`/accounting/accounts/${id}/subaccounts`);
  }

  createAuxAcounts(uid: string, cid: string | null, id: number, data: any): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.post<any>(`/accounting/accounts/${id}/subaccounts`, data);
  }

  updateSubContableAcounts(account: string, id: number, data: any): Observable<any> {
    const httpClient = new HttpClient("", "");
    return httpClient.put<any>(`/accounting/account/${account}/subaccount/${id}`, data);
  }
}
